module.exports = __webpack_public_path__ + "img/Full-Screen.9ffd2e05.svg";